import { NoShowData } from './../models/request/StatusChangeRequest';
import { Reservation } from "./../models/assignato/reservation";
import { ReservationsResponse } from "@/models/responses/ReservationsResponse";
import { http } from "./HttpService";
import { StatusChangeResponse } from "@/models/responses/StatusChangeResponse";
import { StatusChangeRequest } from "@/models/request/StatusChangeRequest";
import { ReservationsByStatusResponse } from '@/models/responses/ReservationsByStatusResponse';
import { ReservationStatus } from '@/models/enum/ReservationStatus';
import { SettingResponse, SettingsResponse } from '@/models/responses/SettingResponse';
import { VersionResponse, VersionsResponse } from '@/models/responses/VersionResponse';
import { Vehicle } from '@/models/assignato/vehicle';
import { useAuthenticationStore } from '@/stores/authentication';
import { UpdateTrafficResponse } from '@/models/responses/UpdateTrafficResponse';
import { Driver } from '@/models/assignato/driver';

class AssignatoApiService {
  STATUS = {} as any;

  constructor() {
    this.STATUS = {
      waiting: process.env.VUE_APP_STATUS_WAITING_ON_MEETING_POINT,
      onWayToPoint: process.env.VUE_APP_STATUS_ON_WAY_TO_MEETING_POINT,
      onBoard: process.env.VUE_APP_STATUS_CUSTOMER_ON_BOARD,
      noShow: process.env.VUE_APP_STATUS_NO_SHOW,
      completed: process.env.VUE_APP_STATUS_COMPLETED,
    };
  }

  async getReservations(): Promise<Array<Reservation>> {
    let response: any;

    try {
      const resp = (await http.get<ReservationsResponse>( process.env.VUE_APP_API_RESERVATION ));

      response = resp.data || [];
    } catch (error) {
      response = [];
    }

    return response;
  }

  async getReservationsByStatus(status: ReservationStatus, search: string = "", limit: number = 10, page: number = 1): Promise<ReservationsByStatusResponse> {
    let response: ReservationsByStatusResponse;
    try {
      response = await http.get<any, ReservationsByStatusResponse>(`${process.env.VUE_APP_API_RESERVATION_DRIVER}/${status.toString()}`, {
        params: {
          search,
          limit,
          page
        }
      });
    } catch (error) {
      response = {};
    }

    return response;
  }

  async getReservationById(id: string) {
    let response: Reservation;

    try {
      response = await http.get<any, Reservation>(`${process.env.VUE_APP_API_RESERVATION_BY_ID}/${id}`);
    } catch (error) {
      return response = {};
    }

    return response;
  }

  async getVehicleSearch(query: string, limit: number = 5): Promise<Array<Vehicle>> {
    let response: Array<Vehicle>;
    let userStore = useAuthenticationStore();

    try {
      response = await http.get<any, Array<Vehicle>>(`${process.env.VUE_APP_API_SEARCH_VEHICLE}/${userStore.user?.driver?.provider_id}`, {
        params: {
          search: query,
          length: limit
        }
      });
    } catch (error) {
      response = [];
    }

    return response;
  }


  async getDriverSearch(query: string, limit: number = 5): Promise<Array<Driver>> {
    let response: Array<Driver>;
    let userStore = useAuthenticationStore();

    try {
      response = await http.get<any, Array<Driver>>(`${process.env.VUE_APP_API_SEARCH_DRIVER}/${userStore.user?.driver?.provider_id}`, {
        params: {
          search: query,
          length: limit
        }
      });
    } catch (error) {
      response = [];
    }

    return response;
  }

  async updateTraffic(reservation_id: number, driver_id?: number, vehicle_id?: number): Promise<UpdateTrafficResponse> {
    let response: UpdateTrafficResponse;

    try {
      response = await http.put<any, UpdateTrafficResponse>(`${process.env.VUE_APP_API_UPDATE_TRAFFIC}/${reservation_id}`, {
        driver_id,
        vehicle_id,
      });
    } catch (error: any) {
      response = {
        error_message: error,
        status: 500,
        item: {}
      };
    }

    return response;
  }

  async updateRoute(reservation_id: any, driver_id?: any, vehicle_id?: any, lat?: any, lgn?: any, status?: string): Promise<UpdateTrafficResponse> {
    let response: UpdateTrafficResponse;

    try {
      let params = {
        driver_id : driver_id,
        service_number: reservation_id ,
        change_status: false,
        lat: lat,
        lng: lgn
      };
      response = await http.post<any, UpdateTrafficResponse>(`${process.env.VUE_APP_API_CHANGE_STATUS_TRAFFIC}/${status}`, params);
    } catch (error: any) {
      response = {
        error_message: error,
        status: 500,
        item: {}
      };
    }

    return response;
  }


  async getSettings(): Promise<SettingResponse> {
    let response: SettingResponse = new SettingResponse();
    try {
      const apiResponse = await http.get<any, SettingsResponse>(process.env.VUE_APP_API_SETTINGS);
      if (apiResponse && apiResponse.code == 200 && apiResponse.response) {
        response = apiResponse.response;
      }
    } catch (error) {
      response = {};
    }

    return response;
  }

  async getVersions(): Promise<VersionResponse> {
    let response: VersionResponse = new VersionResponse();
    try {
      const apiResponse = await http.get<any, VersionsResponse>(process.env.VUE_APP_API_VERSIONS);
      if (apiResponse && apiResponse.code == 200 && apiResponse.response) {
        response = apiResponse.response;
      }
    } catch (error) {
      response = {};
    }

    return response;
  }

  async onReservationChangeStatus(
    status: string,
    id: number,
    dataNoShow: NoShowData = {}
  ): Promise<StatusChangeResponse> {
    let params = new StatusChangeRequest();
    params = {
      driver_id: 0,
      version: "",
      platform: "",
      service_number: id,
      comments: dataNoShow.comments,
      lat: dataNoShow.lat,
      lng: dataNoShow.lng,
      images: dataNoShow.images
    };

    const url = `${process.env.VUE_APP_API_CHANGE_STATUS}${status || this.STATUS.waiting}`;
    let response: StatusChangeResponse = new StatusChangeResponse();

    response = await http.post<StatusChangeRequest, StatusChangeResponse>(
      url,
      params
    );
    return response;
  }
}

export default new AssignatoApiService();
